<template>
  <div>
    <div class="ibox mx-2">
      <div class="ibox-title">
        Platform
      </div>

      <div class="ibox-content">
        <div class="row">
          <div class="col-sm-3" v-for="page in pages" :key="page.name">
            <router-link tag="div" :to="`/admin/${page.path}`" class="card card-admin">
              <div class="card-body text-center">
                <strong>
                  {{ page.name }}
                </strong>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div class="ibox mx-2">
      <div class="ibox-title">
        Microservices
      </div>

      <div class="ibox-content">
        <div class="row">
          <div class="col-sm-3" v-for="page in secondaryPages" :key="page.name">
            <router-link tag="div" :to="page.path" class="card card-admin">
              <div class="card-body text-center">
                <strong>
                  {{ page.name }}
                </strong>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pages: [
          { name: 'Eventos', path: 'events' },
          { name: 'Apps', path: 'apps' },
          { name: 'Usuários', path: 'users' },
          { name: 'Contas', path: 'accounts' },
          { name: 'Empresas', path: 'companies' },
          { name: 'Financeiro', path: 'financeiro' },
          { name: 'Veículos', path: 'vehicles' },
          { name: 'Motoristas', path: 'drivers' },
          { name: 'Associados', path: 'associates' },
          { name: 'Credenciais', path: 'credentials' },
          { name: 'E-mails', path: 'emails' },
          { name: 'Templates de E-mail', path: 'email_templates' },
          { name: 'Notificações enviadas', path: 'notifications' },
          { name: 'Notificações automáticas', path: 'notification-templates' },
          { name: 'Observadores', path: 'observers' },
          { name: 'Documentos', path: 'documents' },
          { name: 'Calendário', path: 'calendars' },
          { name: 'Custom Table', path: 'custom_tables' },
          { name: 'Models', path: 'models' },
          { name: 'Distribuição NSU', path: 'nsu_distributions' },
          { name: 'SQS Messages', path: 'sqs_messages' },
          { name: 'Contador', path: 'counters' },
          { name: 'Relatórios', path: 'reports' },
          { name: 'Contrato de troca de Payloads', path: 'payloads' },
          { name: 'Orders', path: 'orders' },
          { name: 'Orders Embarcador', path: 'orders_embarcador' },
          { name: 'Items', path: 'items' },
          { name: 'Documentation Items', path: 'documentation_items' },
          { name: 'Agendamentos', path: 'event_schedules' },
          { name: 'Volumetria de Consultas', path: 'volumetria' },
          { name: 'Template Services', path: 'template_services' },
          { name: 'Feature Flags', path: 'feature_flags' },
          { name: 'Entity Statuses', path: 'entity_statuses' }
        ],
        secondaryPages: [
          { name: 'Maestro', path: 'admin/maestro' },
          { name: 'UnicoIntegration', path: 'admin/unico_integration' },
          { name: 'CityHallMapper', path: 'admin/city_hall_mapper' },
          { name: 'CustomTable', path: 'custom_table' },
          { name: 'Doc Hub', path: 'admin/doc-hub' }

        ],
        response: {},
        url: ''
      }
    },
    methods: {
    },
    name: 'Index'
  }
</script>

<style scoped>

  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }

  .event-detail * {
    background: #051724;
    color: #FFF;
    padding: 16px;
    border-radius: 8px;
  }

</style>
